(function($) {
    "use strict";

    // Return if not proper template
    if ( !$('body').hasClass('page-template-hub-workersStories') ) return;

    $(function() {

        var workerString = '';

        var workerKeywords = $('.resources-page-filter-input input');

        workerKeywords.on('input', function( event ) {
            updateURIParameterByName( 'search', event.target.value );
        });

        var workerState = $('select.hub-page-filter-state').select2({
            placeholder: 'Data type',
            minimumResultsForSearch: Infinity,
            allowClear: true,
            dropdownCssClass: "dark-dropdown"
        });

        workerState.on( 'select2:select', function( event ) {
            var value = workerState.val();
            updateURIParameterByName( 'state', value );
        });

        var workerOcсupation = $('select.hub-page-filter-occupation').select2({
            placeholder: 'Data type',
            minimumResultsForSearch: Infinity,
            allowClear: true,
            dropdownCssClass: "dark-dropdown"
        });

        workerOcсupation.on( 'select2:select', function( event ) {
            var value = workerOcсupation.val();
            updateURIParameterByName( 'occupation', value );
        });

        var workerTopic = $('select.hub-page-filter-topic').select2({
            placeholder: 'Data type',
            minimumResultsForSearch: Infinity,
            allowClear: true,
            dropdownCssClass: "dark-dropdown"
        });

        workerTopic.on( 'select2:select', function( event ) {
            var value = workerTopic.val();
            updateURIParameterByName( 'topic', value );
        });

        $('.worker-stories-list .hub-page-worker-stories__filter .search').on('click', function(el){
            el.preventDefault();
            var fullList = $('.worker-stories-list > .feature-block-grid');
            var resultList = $('.worker-stories-list #results-list');
            var overlay = $('.worker-stories-list #results-list .loading-overlay');
            var stateVal = $('.worker-stories-list .hub-page-filter-state').val();
            var occupationVal = $('.worker-stories-list .hub-page-filter-occupation').val();
            var topicVal = $('.worker-stories-list .hub-page-filter-topic').val();
            var searchBtn = $('.worker-stories-list .hub-page-worker-stories__filter .search');
            var clearBtn = $('.worker-stories-list .hub-page-worker-stories__filter .clear');

            resultList.find('.grid-inner-block').empty();


            if(!(stateVal || occupationVal || topicVal)) {
                fullList.show();
                resultList.hide();
            }

            if(stateVal || occupationVal || topicVal) {

                fullList.hide();
                resultList.show();

                $.ajax({
                    url  : phi_theme.ajax_url,
                    type : 'post',
                    data : {
                        'action': 'worker_stories_filter',
                        'stateVal': stateVal,
                        'occupationVal': occupationVal,
                        'topicVal': topicVal,
                    },
                    beforeSend: function() {
                      overlay.show();
                   },
                    success : function( response ) {
                        console.log('response', response);
                        if(response.data) {
                            var DOM = new DOMParser().parseFromString(response.data, 'text/html');

                            resultList.find('.grid-inner-block').append(response.data);
                        } else {
                             resultList.find('.grid-inner-block').append('<p class="no-result"> No items found</p>');
                             searchBtn.hide();
                             clearBtn.show();
                        }
                    },
                    complete:function(data){
                        overlay.hide();
                   }
                });
            }
        });

        $('.worker-stories-list .hub-page-worker-stories__filter .clear').on('click', function(){
            location.reload();
        });

        // Update URI vars
        var updateURIParameterByName = function( name, value ) {
            var re = new RegExp("([#&])" + name + "=.*?(&|$)", "i"),
                separator = workerString.indexOf('#') !== -1 ? "&" : "#",
                updatedURL = '';
            if ( value === null ) value = '';
            if (workerString.match(re)) {
                if ( value === '' ) {
                  updatedURL = workerString.replace(re, '$1' + '$2');
                } else {
                  updatedURL = workerString.replace(re, '$1' + name + "=" + value + '$2');
                }
            } else {
                if ( value === '' ) {
                  updatedURL = workerString;
              } else {
                  updatedURL = workerString + separator + name + "=" + value;
              }
            }
            workerString = updatedURL.replace('&&','&');
        };

    });

})(jQuery);
